










































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment-timezone'
import VueJsonPretty from 'vue-json-pretty'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { cloneDeep, debounce } from 'lodash-es'
import './OrderReportList.scss'
import { orderTypeList as orderTypeListALL, orderTypeListRoom, desktopOrderItemStatus } from '@/utils/orderConstant'
import { downloadCSV, showConfirmButton } from '@/utils/helpers'
import OrderReportListCard from '@/components/OrderList/OrderReportListCard.vue'
import OrderReportListDetail from '@/components/OrderList/OrderReportListDetail.vue'
import StoreProcessingDetails from '@/components/OrderList/StoreProcessingDetails.vue'
import api from '@/api'
import constants from '@/utils/constants'
import PosOrderModal from '@/components/PosOrderModal.vue'

library.add(faDownload)

class OrderReportListItem {
  id: string = ''
  orderId: string = ''
  outletCode: string = ''
  orderType: string = ''
  createdAt: string = ''
  orderStatus: string = ''
  phoneNumber: string = ''
  cancelStatus: string = ''
  totalPoints: string = ''
}

@Component({
  components: {
    VueJsonPretty,
    OrderReportListCard,
    OrderReportListDetail,
    StoreProcessingDetails,
    PosOrderModal
  },
  filters: {
    formatDate(val: any) {
      let date: any = val
      if (moment(date).isValid()) {
        date = moment(date).format('YYYY-MM-DD')
      }
      return date
    }
  },
  directives: {
    changeStyle: {
      inserted(el, binding) {
        if (el.innerHTML === 'QR Dine-in') {
          el.classList.add('itemCenter')
        }
      }
    }
  }
})
export default class OrderReportListDesktop extends Vue {
  get userType() {
    return this.$store.state.currentUser
      ? this.$store.state.currentUser.Type
      : ''
  }

  get filteredRestaurantItems() {
    if (!this.outletFilterText) return this.restaurantItem
    const search = this.outletFilterText.toLowerCase()
    return this.restaurantItem.filter((item: any) =>
      item.text.toLowerCase().includes(search)
    )
  }

  isRunner: boolean = this.userType === 'Runner'
  isAdmin: boolean = this.userType === 'Admin'
  perPage = 20
  filterItem = this.filtering
  hasNoDataModal: boolean = false
  isDownLoadBusy: boolean = false
  isRestaurantItemLodaing: boolean = true
  constants: any = constants
  isChecking: boolean = false
  showConfirmButton: any = showConfirmButton
  initItems = {
    dateFrom: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day - 7
    ),
    dateTo: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day
    ),
    selectedOutletCodes: []
  }
  dateitems = {
    ...this.initItems
  }
  orderTypeList: any = this.isRunner ? orderTypeListRoom : orderTypeListALL
  orderTypes = this.orderTypeList
  moreTypes: Array<any> = []
  $swal: any
  activeOrderType =
    this.$store.getters.GetActiveOrderType || this.orderTypeList[0].type
  orderStatusButtons: Array<any> = this.orderTypeList[0].orderStatus
  activeOrderStatus: string = 'IN_PROGRESS'
  inputOrderId = ''
  currentItem: Object = {}
  ischeckRestaurantShow: boolean = false
  isConfirmBoxShow: boolean = false
  isModelShow: boolean = false
  confirmModelTitle: string = ''
  itemOrderStatus: String = ''
  nextStatusValue: String = ''
  isRejectBoxShow: boolean = false
  itemOrderId: String = ''
  detailOrderId: string = ''
  isMoreShow: boolean = false
  getDetailItem: Array<any> = []
  currentDetailItem: any = {
    orderId: '',
    contact: {
      name: ''
    },
    address: {
      deliveryAddress: ''
    },
    user: {
      customerName: '',
      phoneNumber: ''
    }
  }
  detailButton: any = ''
  detailButtonShow: boolean = true
  rejectItem: Object = {}
  isStoreProcessingDetails: boolean = true
  isOrderReportListDetail: boolean = false
  isChooseMore: boolean = false
  dataStatus: boolean = false
  isOrderCardShow: boolean = true
  isPosOrderModelShow: boolean = false
  buttonStatusStyle: String = ''
  formCheckBox: boolean = true
  isNoFlip: boolean = false
  exportButton: boolean = false
  loginID: any = ''
  downLoadInStore: Array<any> = []
  downLoadDelivery: Array<any> = []
  downLoadTakeAway: Array<any> = []
  downLoadTableOrder: Array<any> = []
  orderStatus: any = desktopOrderItemStatus
  restaurantItem: any = []
  outletFilterText: string = ''
  currentRestaurantName: String = 'Outlet Code'
  currentRestauranValue: String = ''
  isCheckUserType: number = 0
  onClickForRefresh: any = null
  currentType: any = ''
  isLoadMoreOutlet: boolean = false
  loadMoreShow: boolean = false
  isPaymentDetailShow: boolean = false
  orderItem: any = {}
  buttonText: string = ''
  outletInfo: any = []
  rejectCurrentDetailItem: { outletCode: string, voidValidate: number, paymentMethod: string, totalSales: number, cimbCallbackData: string } = {
    outletCode: '',
    voidValidate: 0,
    paymentMethod: '',
    totalSales: 0,
    cimbCallbackData: ''
  }
  password: string = ''
  orderTypeDefaultFilter = this.isRunner ? 'ROOM' : ''
  selectedOutlet: any = null

  created() {
    this.onClickForRefresh = debounce(this.refreshData, 300)
  }

  async mounted() {
    this.$store.commit('SET_PAGING_PAGE_STORE', 1)
    this.$store.commit('SET_FILTERING_STORE', {})
    const uid = localStorage.getItem('UID')
    const outletCodes = localStorage.getItem('outletCodes')!.split(',')
    let outletInfo: any = []
    if (localStorage.getItem('selected-outlet')) {
      this.selectedOutlet = JSON.parse(localStorage.getItem('selected-outlet') || '{}')
    }
    if (this.isAdmin || outletCodes.length) {
      let outletList = []
      if (localStorage.getItem('outletList')) {
        outletList = JSON.parse(localStorage.getItem('outletList') || '[]')
      } else {
        await api
          .GetAllStoreForNewPort(
            { page: 1, size: outletCodes.length },
            { byField: '', isDesc: '' },
            {},
            uid
          )
          .then(res => {
            try {
              outletList = res.data.result.data
            } catch (error) {
              throw error
            }
          })
      }
      if (outletList) {
        for (let i = 0; i < outletList.length; i++) {
          const element: any = outletList[i]
          outletInfo.push({
            outletType: element.type,
            value: element.outlet_code,
            text: element.outlet_code + ' - ' + element.name,
            type: element.outlet_code + ' - ' + element.name,
            ...element
          })
        }
      }
      if (!this.selectedOutlet && outletInfo.length) {
        localStorage.setItem('selected-outlet', JSON.stringify(outletInfo[0]))
        this.selectedOutlet = outletInfo[0]
      }
      this.outletInfo = outletInfo
    }
    if (this.selectedOutlet && this.selectedOutlet.id) {
      localStorage.setItem('pos-order-outlet', JSON.stringify(this.selectedOutlet))
      this.currentRestaurantName = this.selectedOutlet.text
      this.currentRestauranValue = this.selectedOutlet.value
      this.setFilter('outletCode', this.selectedOutlet.value)
    }
    this.setFilter('orderType', '')
    this.switchOrderType('ALL')
    this.handleClickOrderStatus(this.orderTypeList[0].orderStatus[0])
    this.watchOrderNumber()
  }

  beforeDestroy() {
    this.resetFilter()
    this.$store.commit('SET_FILTERING_ORDERREPORT', this.filterItem)
  }

  handleRedirect(orderId) {
    this.$router.push(`/order-report/online/${orderId}`)
  }

  get items(): OrderReportListItem[] {
    return this.$store.getters.GetAllOrderReport
  }

  get orderNumber() {
    return this.$store.getters.GetAllOrderNumber
  }

  get paging() {
    return this.$store.getters.PagingOrderReport
  }

  get filtering() {
    return this.$store.getters.FilteringOrderReport
  }

  get hasNoData() {
    return (
      this.$store.getters.GetHasNoData && this.$store.getters.GetFromFilterView
    )
  }

  get isLoadingShow() {
    return this.$store.getters.GetIsLoadingShow
  }

  get updateOrderStatus() {
    return this.$store.getters.GetUpdateOrderStatus
  }

  get cancelOrderStatus() {
    return this.$store.getters.CancelOrderStatus
  }

  get isVoiceShow() {
    return this.$store.getters.GetIsVoiceShow
  }

  get currentDate() {
    const now = new Date()
    return {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: now.getDate() + 1
    }
  }

  get progressCount() {
    return this.$store.getters.GetInProgressCount
  }

  get GetNewOrderComing() {
    return this.$store.getters.GetNewOrderComing
  }

  get PagingStore() {
    return this.$store.getters.PagingStore
  }

  get GetFirstOrder() {
    return this.$store.getters.GetFirstOrder
  }

  changeVoiceData() {
    this.$store.commit('SET_ISVOICESHOW')
  }

  discardNoData() {
    this.$store.commit('SET_ERROR_DATA', false)
    this.hasNoDataModal = false
  }

  checkOutItems() {
    if (this.items.length === 0) {
      this.dataStatus = true
      this.isOrderCardShow = false
    } else {
      this.dataStatus = false
      this.isOrderCardShow = true
    }
  }

  doSearch(fromFilter: boolean = false) {
    this.$store.commit('SET_FILTERING_ORDERREPORT', this.filterItem)
    this.reload(1, fromFilter)
  }

  refreshData() {
    this.$store.dispatch('GetAllOrderReport')
  }

  setFilter(key, value) {
    this.filterItem[key] = value
  }

  resetFilter() {
    this.filterItem = {
      orderId: '',
      outletCode: '',
      orderType: '',
      orderStatus: [],
      createdAt: {
        startDate: '',
        endDate: ''
      },
      phoneNumber: '',
      cancelStatus: []
    }
  }

  reload(page: any = null, fromFilter: boolean = false) {
    if (page) {
      this.$store.commit('SET_PAGING_PAGE_ORDERREPORT', page)
    }
    this.$store.dispatch('GetAllOrderReport', { fromFilter }).then(() => {
      this.hasNoDataModal = this.hasNoData
    })
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7
    }
    if (page > Math.ceil(total / this.perPage) - 5) {
      return 7
    }
    return 5
  }

  makeChoose(item) {
    this.activeOrderStatus = item.value
    this.detailButtonShow = true
    this.dataStatus = false
    this.isOrderCardShow = true
    this.setFilter('orderStatus', item.status)
  }

  handleClickOrderStatus(item) {
    this.isChooseMore = false
    this.setFilter('orderId', '')
    this.detailButtonShow = true
    this.dataStatus = false
    this.isOrderCardShow = true
    if (this.activeOrderStatus === item.value) {
      return
    }
    this.activeOrderStatus = item.value
    this.setFilter('orderStatus', item.status)
  }

  @Watch('$store.getters.GetActiveOrderType')
  watchActiveOrderType(newval) {
    this.switchOrderType(newval || 'ALL')
  }

  switchOrderType(type) {
    this.activeOrderType = type
    this.activeOrderStatus = 'IN_PROGRESS'
    this.handleOrderStatus()
    this.$store.commit('SET_ACTIVE_ORDERTYPE', type === 'ALL' ? '' : type)
    this.$store.commit(
      'SET_INPROGRESS_STATUS',
      this.orderStatusButtons[0].status
    )
    this.dataStatus = false
    this.isOrderCardShow = true
  }

  handleOrderStatus() {
    this.isChooseMore = false
    this.isMoreShow = false
    this.isOrderReportListDetail = true
    this.isStoreProcessingDetails = false
    this.detailButtonShow = true
    this.setFilter('orderId', '')
    let moreTypes: Array<any> = []
    let orderStatusButtons: Array<any> = []
    orderStatusButtons = cloneDeep(
      this.orderTypeList.filter(item => item.type === this.activeOrderType)[0]
        .orderStatus
    )
    let status = orderStatusButtons.filter(
      item => item.value === this.activeOrderStatus
    )[0].status
    if (this.activeOrderType === 'ALL' && orderStatusButtons.length > 7) {
      this.isMoreShow = true
      for (let i = 0; i < orderStatusButtons.length; i++) {
        const element = orderStatusButtons[i]
        if (i > 5) {
          moreTypes.push(element)
        }
      }
      this.moreTypes = moreTypes
      orderStatusButtons = orderStatusButtons.splice(0, 6)
    }
    this.downLoadInStore = status.map(value => {
      return { value }
    })
    this.setFilter('orderStatus', status)
    this.setFilter(
      'orderType',
      this.activeOrderType === 'ALL'
        ? this.orderTypeDefaultFilter
        : this.activeOrderType
    )
    this.orderStatusButtons = orderStatusButtons
  }

  handleNextStatus(status, type) {
    const currentStatus = this.orderStatus[status]
    if (currentStatus.nextStatus) {
      return this.orderStatus[currentStatus.nextStatus]
    }
    if (type === constants.PPTA && status === 'READY_PICKUP') {
      return Object.values(this.orderStatus).find(
        (item: any) => item.flowPosition === currentStatus.flowPosition + 2
      )
    } else if (type === constants.PPDI && status === 'READY_PICKUP') {
      return Object.values(this.orderStatus).find(
        (item: any) => item.flowPosition === currentStatus.flowPosition + 2
      )
    } else if ((type === constants.TOP || type === constants.ROOM) && status === 'READY_PICKUP') {
      return Object.values(this.orderStatus).find(
        (item: any) => item.flowPosition === currentStatus.flowPosition + 2
      )
    } else {
      return Object.values(this.orderStatus).find(
        (item: any) => item.flowPosition === currentStatus.flowPosition + 1
      )
    }
  }

  handleClickInputOrderId() {
    this.setFilter('orderId', this.inputOrderId)
    this.inputOrderId = ''
  }

  setCurrentItem(newValue) {
    this.currentItem = newValue
  }

  showRestaurantItem() {
    if (this.isCheckUserType === 0) {
      this.isRestaurantItemLodaing = true

      if (this.isAdmin) {
        let data: any = [{ text: 'ALL', type: 'ALL', value: 'ALL' }]
        this.$store.dispatch('GetAllStore').then(resp => {
          resp.data.map(v => {
            data.push({
              text: `${v.outletCode} - ${v.name}`,
              type: `${v.outletCode} - ${v.name}`,
              value: parseInt(v.outletCode)
            })
          })
          this.restaurantItem = data
          this.isRestaurantItemLodaing = false
          this.loadMoreShow = true
        })
      } else if (!this.isAdmin && this.outletInfo.length !== 0) {
        let data: any = [
          {
            text: 'ALL',
            type: 'ALL',
            value: 'ALL'
          }
        ]
        this.outletInfo.map(v => {
          data.push({
            text: v.text,
            type: v.text,
            value: v.value
          })
        })
        this.restaurantItem = data
        this.isRestaurantItemLodaing = false
        this.loadMoreShow = false
      } else if (!this.isAdmin && this.outletInfo.length === 0) {
        let data: any = [
          {
            text: 'No restaurant data',
            type: 'No restaurant data',
            value: 'No restaurant data'
          }
        ]
        this.restaurantItem = data
        this.isRestaurantItemLodaing = false
        this.loadMoreShow = false
      }
      this.isCheckUserType = 1
    }
    this.ischeckRestaurantShow = !this.ischeckRestaurantShow
  }

  loadMoreOutlet() {
    this.isLoadMoreOutlet = true
    this.$store.commit('SET_PAGING_PAGE_STORE', this.PagingStore.page + 1)
    this.$store.dispatch('GetAllStore').then(resp => {
      resp.data.map(v => {
        this.restaurantItem.push({
          text: `${v.outletCode} - ${v.name}`,
          type: `${v.outletCode} - ${v.name}`,
          value: parseInt(v.outletCode)
        })
      })
      this.isLoadMoreOutlet = false
    })
  }

  showModelBox(buttonValue, buttonText, title = '') {
    this.itemOrderStatus = buttonValue
    this.isConfirmBoxShow = true
    this.isModelShow = true
    this.confirmModelTitle = title
    this.nextStatusValue = buttonText
    if (buttonText === 'PREPARING') {
      this.buttonText = buttonText
    } else {
      this.buttonText = ''
    }
  }

  showPosOrder() {
    this.isPosOrderModelShow = true
  }

  posOrderPopup(value) {
    this.isPosOrderModelShow = value
  }

  posOrderValue(value) {
    this.reload()
  }

  hideConfirmBox() {
    this.isRejectBoxShow = false
    this.isConfirmBoxShow = false
    this.isModelShow = false
  }

  showCancelBox(cancelValue, item, currentDetailItem) {
    this.password = ''
    this.isRejectBoxShow = true
    this.isModelShow = true
    this.rejectItem = item
    this.rejectCurrentDetailItem = currentDetailItem
  }

  cancel() {
    this.isRejectBoxShow = false
    this.isModelShow = false
  }

  switchOrderDetail(orderId, orderStatus, orderType, outletCode, item) {
    this.buttonStatusStyle = orderStatus
    this.itemOrderId = orderId
    this.detailOrderId = orderId
    this.getDetailItem = this.items
    this.detailButtonShow = true
    this.orderItem = item
    this.getDetailItem.map(items => {
      if (items.orderId === this.detailOrderId) {
        this.currentDetailItem = items
      }
    })
    const currentStatus = this.orderStatus[orderStatus]
    if (currentStatus.buttonShow === true) {
      this.detailButton = this.handleNextStatus(orderStatus, orderType)
    } else {
      this.detailButtonShow = false
    }
  }

  changeDropDownStyle() {
    this.activeOrderStatus = ''
    this.isChooseMore = true
  }

  confirm(items) {
    this.isModelShow = !this.isModelShow
    this.isConfirmBoxShow = !this.isConfirmBoxShow
    this.detailButtonShow = true
    const UserName: any = localStorage.getItem('UserName')
    if (this.buttonText) {
      if (window && typeof (window as any).android !== 'undefined') {
        (window as any).android.printBill(
          JSON.stringify(this.orderItem),
          UserName
        );
        (window as any).android.printBill(
          JSON.stringify(this.orderItem),
          UserName,
          0,
          0
        )
      }
    }
    this.$store
      .dispatch('UpdateOrderStatus', {
        orderId: this.itemOrderId,
        order_status: this.itemOrderStatus
      })
      .then(res => {
        // No temporary simulation order quantity out of the interface
        this.checkInProgressCount('COMPLETED')
      })
  }

  async reject() {
    if (!this.password) {
      return this.$swal(
        constants.SOMETHING_WROING,
        this.voidValidate ? 'Please input the PIN' : 'Please input the code',
        constants.STATUS_ERROR
      )
    }
    if (this.voidValidate) {
      try {
        this.isChecking = true
        const response: any = await this.$store.dispatch('CheckStorePin', {
          outletCode: this.rejectCurrentDetailItem.outletCode,
          pinCode: this.password
        })
        if (!response.data.validate) {
          return this.$swal(
            constants.SOMETHING_WROING,
            'Invalid PIN',
            constants.STATUS_ERROR
          )
        }
      } catch (error) {
        return this.$swal(
          constants.SOMETHING_WROING,
          error,
          constants.STATUS_ERROR
        )
      } finally {
        this.isChecking = false
      }
    } else {
      if (this.rejectCurrentDetailItem.outletCode !== this.password) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'Please input the correct code',
          constants.STATUS_ERROR
        )
      }
    }
    this.isModelShow = false
    this.isRejectBoxShow = false
    console.log(this.rejectCurrentDetailItem)
    if (this.rejectCurrentDetailItem.paymentMethod === 'CIMB-QR' ||
      this.rejectCurrentDetailItem.paymentMethod === 'CIMB-DEBIT' ||
      this.rejectCurrentDetailItem.paymentMethod === 'CIMB-CREDIT') {
      let cimbCallbackData = JSON.parse(this.rejectCurrentDetailItem.cimbCallbackData)
      const transType = this.rejectCurrentDetailItem.paymentMethod === 'CIMB-QR' ? 'QRMPM' : 'SALE'
      console.log(this.rejectItem)
      console.log(transType)
      console.log(cimbCallbackData.traceNo)
      console.log(this.rejectCurrentDetailItem.totalSales)
      console.log(cimbCallbackData.referenceId ? cimbCallbackData.referenceId : '')
      if (window && typeof (window as any).android !== 'undefined') {
        (window as any).android.voidCimbPayment(
          this.rejectItem,
          transType,
          cimbCallbackData.traceNo,
          this.rejectCurrentDetailItem.totalSales,
          cimbCallbackData.referenceId ? cimbCallbackData.referenceId : ''
        )
      } else {
        this.$swal(
          constants.SOMETHING_WROING,
          'need to void CIMB payment in android',
          constants.STATUS_ERROR
        )
      }
    } else {
      const payload = {
        orderId: this.rejectItem,
        pinCode: this.voidValidate ? this.password : undefined
      }
      this.$store.dispatch('CancelOrder', payload)
    }
  }

  checkInProgressCount(status) {
    const orderStatus = this.orderTypeList
      .filter(item => item.type === this.activeOrderType)[0]
      .orderStatus.filter(item => item.value === 'ALL')[0].status
  }

  handleClickCancelButton(item) {
    this.isModelShow = true
    this.isRejectBoxShow = true
    this.rejectItem = item.orderId
  }

  setPerPage() {
    this.$store.state.orderReport.pagingOrderReport.page = 1
    this.$store.state.orderReport.pagingOrderReport.size = this.perPage
    this.$store.dispatch('GetAllOrderReport')
  }

  async downLoadFunction(currentState, orderType) {
    this.exportButton = true
    this.isDownLoadBusy = true
    const outletCodes = localStorage.getItem('outletCodes')
    const payload = {
      isAdmin: this.isAdmin,
      orderType: orderType,
      outletCodes: this.isAdmin ? this.currentRestauranValue : this.currentRestauranValue || outletCodes,
      orderStatus:
        this.activeOrderStatus === 'ALL' ||
        this.activeOrderStatus === 'IN_PROGRESS'
          ? currentState.map(item => item.value)
          : [this.activeOrderStatus]
    }
    const orderData = await this.$store.dispatch(
      'GetDownloadOrderstRequest',
      payload
    )
    if (orderData.invalidMessage !== constants.UPPER_SUCCESS) {
      return this.$swal(
        constants.SOMETHING_WROING,
        orderData.invalidMessage,
        constants.STATUS_ERROR
      )
    }
    downloadCSV(orderData.data, 'order.csv')
    this.isDownLoadBusy = false
    this.exportButton = false
  }

  async downLoad() {
    this.exportButton = true
    this.isDownLoadBusy = true

    if (this.activeOrderType !== 'ALL') {
      this.downLoadFunction(this.downLoadInStore, this.activeOrderType)
    } else {
      const outletCodes = localStorage.getItem('outletCodes')
      const payload = {
        isAdmin: this.isAdmin,
        outletCodes: this.isAdmin ? this.currentRestauranValue : this.currentRestauranValue || outletCodes,
        orderStatus:
          this.activeOrderStatus === 'ALL'
            ? ''
            : this.activeOrderStatus === 'IN_PROGRESS'
              ? this.orderStatusButtons
                .filter(item => item.value === 'IN_PROGRESS')[0]
                .status.map(item => {
                  return { value: item }
                })
              : [this.activeOrderStatus]
      }
      const orderData = await this.$store.dispatch(
        'GetDownloadOrderstRequest',
        payload
      )
      if (orderData.invalidMessage !== constants.UPPER_SUCCESS) {
        return this.$swal(
          constants.SOMETHING_WROING,
          orderData.invalidMessage,
          constants.STATUS_ERROR
        )
      }
      downloadCSV(orderData.data, 'order.csv')
      this.exportButton = false
      this.isDownLoadBusy = false
    }
  }

  disabledExportButtonState() {
    this.exportButton = true
  }

  removeDisabled() {
    this.exportButton = false
  }

  switchRestaurant(restaurantValue, restaurantText) {
    for (let i in this.orderStatus) {
      this.orderStatus[i].quantity = 0
    }
    this.moreTypes.map(v => {
      v.quantity = 0
    })
    this.currentRestauranValue = restaurantValue === 'ALL' ? '' : `${restaurantValue}`
    this.currentRestaurantName = restaurantText
    this.activeOrderStatus = 'IN_PROGRESS'
    this.ischeckRestaurantShow = false
    this.getOrderCountForRestaurant(restaurantValue)
  }

  // No temporary simulation order quantity out of the interface
  getOrderCountForRestaurant(value) {
    if (value === 'ALL') {
      this.currentRestaurantName = 'Outlet Code'
      this.currentRestauranValue = ''
      this.setFilter('outletCode', '')
      if (this.outletInfo) {
        localStorage.setItem(
          'pos-order-outlet',
          JSON.stringify(this.outletInfo[0])
        )
        this.$store.commit('UPDATE_EDC_MODEL', this.outletInfo[0].edc_model)
      }
      localStorage.setItem('selected-outlet', '{}')
      this.handleOrderStatus()
    } else {
      this.setFilter('outletCode', value)
      const getSelectedOutlet = this.outletInfo.find(v => v.value.toString() === value.toString())
      if (getSelectedOutlet && getSelectedOutlet.id) {
        localStorage.setItem('pos-order-outlet', JSON.stringify(getSelectedOutlet))
        localStorage.setItem('selected-outlet', JSON.stringify(getSelectedOutlet))
        this.$store.commit('UPDATE_EDC_MODEL', getSelectedOutlet.edc_model)
      }
      this.handleOrderStatus()
    }
  }

  @Watch('GetNewOrderComing')
  watchNewOrderComing(newValue, oldValue) {
    if (newValue > oldValue) {
      this.handleOrderStatus()
    }
  }

  @Watch('filterItem', { deep: true })
  watchFilterItem() {
    this.doSearch(true)
  }

  @Watch('items')
  watchItems() {
    if (this.items.length === 0) {
      this.dataStatus = true
      this.isOrderCardShow = false
    } else {
      this.orderItem = this.items[0]
      this.dataStatus = false
      this.isOrderCardShow = true
    }
  }

  @Watch('updateOrderStatus.isSuccess')
  watchOrderStatusSuccess() {
    if (this.updateOrderStatus.isSuccess) {
      this.doSearch(true)
    }
  }

  @Watch('updateOrderStatus.error')
  watchOrderStatusError() {
    if (this.updateOrderStatus.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderStatus.error,
        constants.STATUS_ERROR
      )
    }
  }

  @Watch('cancelOrderStatus.isSuccess')
  watchCancleOrderStatus() {
    if (this.cancelOrderStatus.isSuccess) {
      this.doSearch(true)
    }
  }

  @Watch('cancelOrderStatus.error')
  watchOrderCancelError() {
    if (this.cancelOrderStatus.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.cancelOrderStatus.error,
        constants.STATUS_ERROR
      )
    }
  }

  @Watch('orderNumber')
  watchOrderNumber() {
    if (this.orderNumber.length === 0) {
      if (this.activeOrderStatus === 'ALL') {
        for (let i in this.orderStatus) {
          this.orderStatus[i].quantity = 0
        }
        this.moreTypes.map(v => {
          v.quantity = 0
        })
      } else if (this.activeOrderStatus === 'IN_PROGRESS') {
        let data = [
          'TRANSFERRED',
          'PREPARED',
          'READY_PICKUP',
          'ON_DELIVERY',
          'PAYMENT_SUCCESS',
          'SUBMITTED'
        ]
        data.map(v => {
          this.orderStatus[v].quantity = 0
        })
        this.moreTypes.map(v => {
          v.quantity = 0
        })
      } else {
        let status = this.activeOrderStatus
        for (let i in this.orderStatus) {
          if (i === status) {
            this.orderStatus[i].quantity = 0
          }
        }
      }
    } else {
      for (let i = 0; i < this.orderStatusButtons.length; i++) {
        const element = this.orderStatusButtons[i]
        let quantity = 0
        for (let j = 0; j < element.status.length; j++) {
          const item = element.status[j]
          for (let k = 0; k < this.orderNumber.length; k++) {
            const count = this.orderNumber[k]
            if (item === count.order_status) {
              quantity += count.count
            }
          }
        }
        element.quantity = quantity
      }
      if (this.activeOrderType === 'ALL') {
        // let allCount = 0;
        // for (let i = 0; i < this.orderNumber.length; i++) {
        //   const element = this.orderNumber[i];
        //   allCount += element.count;
        // }
        // this.orderStatusButtons[2].quantity = allCount;
        for (let i = 0; i < this.moreTypes.length; i++) {
          const element = this.moreTypes[i]
          let quantity = 0
          for (let j = 0; j < element.status.length; j++) {
            const item = element.status[j]
            for (let k = 0; k < this.orderNumber.length; k++) {
              const count = this.orderNumber[k]
              if (item === count.order_status) {
                quantity += count.count
              }
            }
          }
          element.quantity = quantity
        }
      }
    }
  }

  get voidValidate() {
    return this.rejectCurrentDetailItem.voidValidate
  }
}
